import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useApp } from "../lib/store";
import { ForecastPanel } from "../components/ForecastPanel";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { LineChart } from "lucide-react";

export default function CustomerForecast() {
  const { t } = useApp();
  const [accounts, setAccounts] = useState([]);
  const [accId, setAccId] = useState("");

  useEffect(() => {
    api.get("/accounts").then((r) => {
      const a = Array.isArray(r.data) ? r.data : (r.data.items || r.data.data || []);
      const sorted = [...a].sort((x, y) => (x.name || "").localeCompare(y.name || ""));
      setAccounts(sorted);
      if (sorted[0]) setAccId(sorted[0].id);
    }).catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="customer-forecast-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 flex items-center gap-2" style={{ fontFamily: "Work Sans" }}>
          <LineChart className="h-7 w-7 text-[#F5A623]" />{t("customer_forecast")}
        </h1>
        <Select value={accId} onValueChange={setAccId}>
          <SelectTrigger className="w-72 h-9 bg-white" data-testid="cf-account-select"><SelectValue placeholder={t("select_account")} /></SelectTrigger>
          <SelectContent className="max-h-80">
            {accounts.map((a) => <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {accId ? <ForecastPanel accountId={accId} /> : <p className="text-gray-400">{t("loading")}</p>}
    </div>
  );
}
